import api from "@/services/api";

const url = "privacy-category";

const getPrivacyCategories = () => api.get(`${url}/find-all-privacy-category`);

const getPrivacyCategoryById = (id) => api.get(`${url}/find-privacy-category-by-id?id=${id}`); 

const createPrivacyCategory = (category) => api.post(`${url}/create-privacy-category`, category);

const updatePrivacyCategory = (category) => api.put(`${url}/update-privacy-category`, category);

const deletePrivacyCategory = (id) => api.delete(`${url}/delete-privacy-category/${id}`);

export default {
  getPrivacyCategories,
  getPrivacyCategoryById,
  createPrivacyCategory,
  updatePrivacyCategory,
  deletePrivacyCategory,
};
